export default "__VITE_ASSET__CvQUiJAH__"